<template>
    <div class="apprentice-simple-card">
        <design-2021-apprentice-data-table
            :fields="fields"
            :items="schools">
            <template v-slot:options>
                <b-button variant="primary" class="btn-toggle toggle-all" @click="toggleAll">
                    {{ anySelected ? 'Alle scholen deselecteren' : 'alle scholen selecteren' }}
                </b-button>
            </template>
            <template v-slot:cell(actions)="data">
                <div class="add_to_project">
                    <b-form-checkbox
                        v-model="data.item.checked"
                        switch>
                    </b-form-checkbox>
                </div>
            </template>
        </design-2021-apprentice-data-table>
        <b-button
            class="btn-copy"
            variant="primary"
            @click="send">
            Groepen voor geselecteerde scholen kopieren naar volgend jaar.
        </b-button>
    </div>
</template>

<script>
    export default {
        name: 'design-2021-admin-copy-groups-index-component',
        props: {
            schoolsIn: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                fields: [
                    {
                        key: 'name',
                        label: this.$t('common.name'),
                        sortable: true
                    },
                    {
                        key: 'groups_count',
                        label: 'aantal groepen',
                        sortable: true
                    },
                    {
                        key: 'actions',
                        label: this.$t('common.actions')
                    }
                ],
                schools: this.schoolsIn.map(school => ({
                    ...school,
                    checked: false
                }))
            };
        },
        computed: {
            anySelected() {
                return this.schools.some((school) => school.checked);
            }
        },
        methods: {
            toggleAll() {
                const shouldCheckAll = !this.anySelected;
                this.schools.forEach(school => {
                    school.checked = shouldCheckAll;
                });
            },
            send() {
                this.alert.saving();
                let schoolIdArray = this.schools.filter((school) => school.checked).map((school) => school.id);

                let data = {
                    school_ids: schoolIdArray
                };

                this.axios.post(this.routes.adminCopyGroups(), data).then(
                    (response) => {
                        this.alert.success();
                    },
                    (error) => {
                        this.alert.ajaxError();
                    }
                );
            }
        }
    };
</script>

<style scoped lang="scss"></style>
